<!-- eslint-disable vue/valid-v-for -->
<template>
    <div class="mian" :v-loading="loading">
        <el-tabs v-model="activetabName">
            <el-tab-pane label="完成配置" name="first">
                <div class="thrumbnail-show" v-if="activetabName === 'first'">
                    <el-card v-for="(item, index) in productList" :key="index" class="product-card">
                        <div>
                            <el-image :src="item.partThumbnail" :preview-src-list="[item.sourceUrl]"
                                @click="viewHandle($event, item)">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                        <div>
                            <span>{{ item.productName }}({{ item.productCode.split('-')[6] }})</span>
                        </div>
                    </el-card>
                    <map name="planetmap" id="planetmap">
                        <template>
                            <area v-for="(item, index) in mapdPositionList" :key="index"
                                :shape="item.selectType === 1 ? 'circle' : 'rect'" :coords="getCoords(item)"
                                href="javascript:void(0)"
                                @click="setCurEndTimeAndPlay(item.soundStart, item.soundEnd, item.soundPath)"
                                target="_self" alt="点击播放语音" />
                        </template>
                    </map>
                </div>
            </el-tab-pane>
            <el-tab-pane label="坐标管理" name="second">
                <div v-if="activetabName === 'second'">
                    <el-row>
                        <el-col ref="toolmenu">
                            <el-form label-position="left" label-width="80px" size="mini">
                                <el-row>
                                    <el-col :span="12">
                                        <el-row>
                                            <el-form-item label="选择图片">
                                                <div class="upload">
                                                    <el-upload class="avatar-uploader" action="#"
                                                        :show-file-list="false" :auto-upload="false" :multiple="false"
                                                        accept="image/png,image/jpeg,image/jpg"
                                                        :on-change="beforeAvatarUpload">
                                                        <i class="el-icon-plus avatar-uploader-icon"></i>
                                                    </el-upload>
                                                    <el-image v-if="originImg !== ''" :src="originImg"
                                                        :preview-src-list="[originImg]" @click="popImage"
                                                        style="width: 150px; vertical-align: top;"></el-image>
                                                    <map name="planetmap" id="planetmap">
                                                        <template>
                                                            <area v-for="(item, index) in mapdPositionList" :key="index"
                                                                :shape="item.selectType === 1 ? 'circle' : 'rect'"
                                                                :coords="getCoords(item)" href="javascript:void(0)"
                                                                @click="setCurEndTimeAndPlay(item.soundStart, item.soundEnd, item.soundPath)"
                                                                target="_self" title="play sound" />
                                                        </template>
                                                    </map>
                                                </div>
                                            </el-form-item>
                                        </el-row>
                                        <el-row>
                                            <el-form-item v-if="photoName !== ''" label="图片名称">
                                                <el-col :span="18">
                                                    <el-input v-model="photoName" :disabled="true"
                                                        prefix-icon="el-icon-picture-outline"></el-input>
                                                </el-col>
                                            </el-form-item>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="选择语音">
                                                    <div class="upload">
                                                        <el-upload class="avatar-uploader" action="#"
                                                            :show-file-list="false" :file-list="uploadSoundFileList"
                                                            accept=".mp3" :auto-upload="false" :multiple="false"
                                                            :on-change="beforeSoundUpload">
                                                            <i class="el-icon-plus avatar-uploader-icon"></i>
                                                        </el-upload>
                                                    </div>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12" style="overflow: hidden;">
                                                <li v-for="(file, index) in uploadSoundFileList" :key="index"
                                                    class="upload-filelist">
                                                    <i class="el-icon-headset"></i><span>{{ file.name }}</span>
                                                </li>

                                            </el-col>
                                        </el-row>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col>
                                        <div style="float: right;">
                                            <el-button type="warning" size="mini" @click="drawHander">画布</el-button>
                                            <el-button type="primary" size="mini" @click="saveData"
                                                :loading="loading">提交</el-button>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </el-col>
                    </el-row>
                    <el-row>
                        <div class="table">
                            <el-table :data="positionList" row-key="num" :expand-row-keys="expandKeys"
                                @expand-change="expandChange" style="width: 100%" border
                                :height="(panelHeight - 260) + 'px'">
                                <el-table-column prop="num" label="" width="40" type="expand">
                                    <template slot-scope="scope">
                                        <div class="table-audio">
                                            <audio @play="audioPlay($event, scope.row)"
                                                @pause="audioPause($event, scope.row)" :src="getAudioByName(scope.row)"
                                                crossorigin="anonymous" controls="controls">
                                            </audio>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="num" label="编号" width="60" align="center">
                                </el-table-column>
                                <el-table-column prop="type" label="类型" width="60" align="center">
                                </el-table-column>
                                <el-table-column label="坐标" width="300">
                                    <template slot-scope="scope">
                                        <span v-html="scope.row.positionDes"></span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="语音(秒)" min-width="80" width="400" align="center">
                                    <template slot-scope="scope">
                                        <span class="sound-time">开始</span>
                                        <el-input-number v-model="scope.row.start" :precision="2" :step="0.1"
                                            size="mini" :max="3000"></el-input-number>
                                        <span class="sound-time sound-time-end">结束</span>
                                        <el-input-number v-model="scope.row.end" :precision="2" :step="0.1" size="mini"
                                            :max="3000"></el-input-number>
                                    </template>
                                </el-table-column>
                                <el-table-column label="语音文件" align="center">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.soundFileName" placeholder="请选择" size="mini">
                                            <el-option v-for="item in uploadSoundFileList" :key="item.name"
                                                :label="item.name" :value="item.name">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-row>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-drawer title="图片坐标设置" :visible.sync="drawerShow" direction="rtl" size="100%" :show-close="false">
            <template slot="title">
                <el-col :span="8">
                    <el-button type="warning" icon="el-icon-delete" size="mini" @click="clearLast" round>上一个</el-button>
                    <el-button type="danger" icon="el-icon-delete" size="mini" @click="clear" round>全部</el-button>
                    <el-button type="primary" icon="el-icon-close" size="mini" @click="drawerShow = false"
                        circle></el-button>
                </el-col>
            </template>
            <el-col :span="4" ref="leftcol">
                <div class="drawer-left">
                    <el-form label-position="top" label-width="80px" size="mini">
                        <el-form-item label="图片尺寸" class="img-size">
                            <span>{{ imgWidth }}</span>*<span></span><span>{{ imgHeight }}</span>
                        </el-form-item>
                        <el-form-item label="线条尺寸">
                            <el-input-number v-model="settings.lineSize" :min="1" @input="radiochange" :max="5"
                                label="线条尺寸"></el-input-number>
                        </el-form-item>
                        <el-form-item label="勾选图形">
                            <el-radio v-model="radio" @input="radiochange" label="1">圆形</el-radio>
                            <el-radio v-model="radio" @input="radiochange" label="2">矩形</el-radio>
                            <!-- <el-radio v-model="radio" @input="radiochange" label="3">椭圆</el-radio> -->
                            <div>
                                <el-input-number v-if="radio === '1'" v-model="settings.circleR" @change="numberChange"
                                    :min="10" label="半径"></el-input-number>
                                <div>
                                    <span v-if="radio === '2'">长</span>
                                    <el-input-number v-if="radio == 2" v-model="settings.rectWidth"
                                        @change="numberChange" :min="10" label="长"></el-input-number>
                                </div>
                                <div>
                                    <span v-if="radio === '2'">宽</span>
                                    <el-input-number v-if="radio == 2" v-model="settings.rectHeight"
                                        @change="numberChange" :min="10" label="宽"></el-input-number>
                                </div>
                            </div>
                            <div v-show="demoShow" ref="divdemo" class="canvasDemo">
                                <canvas ref="mycanvasDemo"></canvas>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
            <el-col :span="20">
                <div ref="photo" class="photo">
                    <canvas ref="mycanvas" @dblclick="myCanvasClickHandlle"></canvas>
                </div>
            </el-col>
        </el-drawer>
        <div style="display: none;">
            <canvas ref="thrumbCanvas"></canvas>
            <audio ref="myAudio" controls="controls" crossorigin="anonymous"></audio>
        </div>
    </div>
</template>
<script>
import api from '@/utils/api'
import Enumerable from 'linq'
export default {
    props: {
        productList: {
            type: Array,
            default: () => ([{}])
        },
        productCode: {
            type: String
        },
        panelHeight: {
            type: Number
        }
    },
    data () {
        return {
            loading: false,
            drawerShow: false,
            photoName: '', // 上传图片名称
            originImg: '', // 原始上传图片，没有画图过
            uploadFile: '',
            uploadSoundFileList: [], // 上传图片列表
            uploadSoundFile: [], // 上传图片文件列表
            rate: 0, // 图片显示尺寸跟实际尺寸比例
            demoShow: false,
            imgWidth: 0, // 图片实际宽度
            imgHeight: 0, // 图片实际高度
            positionList: [], // 待保存的位置列表
            mapdPositionList: [], // 已提交的位置列表,用于展示效果
            radio: '1', // 矩形还是圆形
            settings: {
                circleR: 80, // demo半径
                rectWidth: 150, // demo宽
                rectHeight: 100, // demo高
                lineSize: 3 // demo边框宽度
            },
            expandKeys: [],
            thurmbnailBase64: '', // 缩略图64
            isSaved: false, // 是否已经保存
            activetabName: 'first'
        }
    },
    mounted () {
        console.log(this.productList)
    },
    methods: {
        test: function () { alert(1) },
        loadCanvas: function (file) {
            var _this = this
            _this.drawerShow = true
            this.$nextTick(function () {
                var canvas = _this.$refs.mycanvas
                var ctx = canvas.getContext('2d')
                var _img = new Image()
                _img.src = file
                _img.onload = function () {
                    canvas.width = _img.width
                    canvas.height = _img.height
                    ctx.drawImage(_img, 0, 0, _img.width, _img.height)
                    _this.setImageSize(_img.height)
                    // _this.rate = _this.$refs.photo.clientWidth / _this.imgWidth
                    _this.rate = canvas.clientWidth / _this.imgWidth
                    _this.dorowDemo()
                    // 如果已画图，则加载数据库数据并绘制
                    _this.positionList.forEach(function (item) {
                        var array = item.position.split(',')
                        var x = parseFloat(array[0])
                        var y = parseFloat(array[1])
                        if (item.type === '圆形') {
                            _this.drawByPosition(canvas, item.type, x, y, parseFloat(array[2]), null, null, 1)// 根据坐标不需要换上比率所以值为1
                        } else {
                            var width = parseFloat(array[2]) - x
                            var height = parseFloat(array[3]) - y
                            _this.drawByPosition(canvas, item.type, x + width / 2, y + height / 2, null, width, height, 1)
                        }
                    })
                }
            })
        },
        setSize: function () {
            this.settings.circleR = (this.imgWidth * 0.05)
            this.settings.rectWidth = (this.imgWidth * 0.1)
            this.settings.rectHeight = (this.imgHeight * 0.1)
        },
        myCanvasClickHandlle: function (event) {
            var e = event || window.event
            var scrollY = document.body.getElementsByClassName('el-drawer__body')[0].scrollTop
            var _this = this
            var canvas = _this.$refs.mycanvas
            // 鼠标点击画图，需要把鼠标坐标转换为图像像素坐标（需要减去滚动、其他组件宽度、高度），中间涉及到图像大小缩放比率，所以需要除以系数，加载时数据库保存的是图像坐标，所以直接加载不需要转换
            var x = e.pageX - _this.$refs.leftcol.$el.clientWidth - (_this.$refs.photo.clientWidth - canvas.clientWidth) / 2
            var y = (e.clientY + scrollY) - 55
            var position = _this.drawByPosition(canvas, _this.radio, x, y, _this.settings.circleR, _this.settings.rectWidth, _this.settings.rectHeight, _this.rate)
            _this.positionList.push(position)
        },
        drawByPosition: function (canvas, type, x, y, r, width, height, rate) {
            var _this = this
            var position = {}
            const ctx = canvas.getContext('2d')
            ctx.lineWidth = _this.settings.lineSize
            ctx.beginPath()
            ctx.strokeStyle = 'red'
            if (type === '1' || type === '圆形') {
                ctx.arc(x / rate, y / rate, r, 0, 2 * Math.PI) // Math.PI圆周率π = 3.14 = 180°
                position = _this.getCirclePosion(x / rate, y / rate, r)
            } else if (type === '2' || type === '矩形') {
                var _width = width
                var _height = height
                ctx.strokeRect(x / rate - _width / 2, y / rate - _height / 2, _width, _height) // 在x轴为10，y轴为10的位置画长为120，宽为80的长方形
                position = _this.getRectPostion(x / rate - _width / 2, y / rate - _height / 2, _width, _height)
            }

            ctx.stroke()
            return position
        },
        dorowDemo: function (isnumchange) {
            if (!isnumchange) {
                this.setSize()
            }
            if (this.demoShow) {
                var canvas = this.$refs.mycanvasDemo
                if (!canvas) {
                    return
                }
                // console.log(this.demoShow)
                var ctx = canvas.getContext('2d')
                var rate = this.rate
                if (this.radio === '1') {
                    // console.log(canvas)
                    canvas.width = (this.settings.circleR || this.$refs.mycanvas.width) * 2 * rate + this.settings.lineSize * 2 + 10
                    canvas.height = (this.settings.circleR || this.$refs.mycanvas.height) * 2 * rate + this.settings.lineSize * 2 + 10
                    this.$refs.divdemo.setAttribute('style', 'width:' + canvas.width + 'px;height:' + canvas.height + 'px')
                    ctx.beginPath()
                    ctx.strokeStyle = 'red'
                    ctx.lineWidth = this.settings.lineSize * rate
                    // console.log(this.settings.circleR * rate + ctx.lineWidth, this.settings.circleR * rate + ctx.lineWidth, this.settings.circleR, 0, 2 * Math.PI)
                    ctx.arc(this.settings.circleR * rate + ctx.lineWidth, this.settings.circleR * rate + ctx.lineWidth, this.settings.circleR * rate, 0, 2 * Math.PI)
                } else if (this.radio === '2') {
                    canvas.width = this.settings.rectWidth * rate + this.settings.lineSize * 2 + 10
                    canvas.height = this.settings.rectHeight * rate + this.settings.lineSize * 2 + 10
                    this.$refs.divdemo.setAttribute('style', 'width:' + canvas.width + 'px;height:' + canvas.height + 'px')
                    ctx.beginPath()
                    ctx.strokeStyle = 'red'
                    ctx.lineWidth = this.settings.lineSize * rate
                    ctx.strokeRect(1, 1, this.settings.rectWidth * rate, this.settings.rectHeight * rate)
                } else {
                    canvas.width = this.settings.rectWidth * rate + this.settings.lineSize * 2 + 100
                    canvas.height = this.settings.rectHeight * rate + this.settings.lineSize * 2 + 100
                    this.$refs.divdemo.setAttribute('style', 'width:' + canvas.width + 'px;height:' + canvas.height + 'px')
                    ctx.beginPath()
                    ctx.strokeStyle = 'red'
                    ctx.lineWidth = this.settings.lineSize * rate
                    ctx.ellipse(this.settings.circleR * rate + ctx.lineWidth, this.settings.circleR * rate + ctx.lineWidth, this.settings.rectWidth * rate / 2, this.settings.rectHeight * rate / 2 - 10, 0, 0, 2 * Math.PI)
                }
                ctx.stroke()
            }
        },
        getCirclePosion: function (x, y, length) {
            return this.setPosition('圆形', x, y, length)
        },
        getRectPostion: function (x, y, width, height) {
            return this.setPosition('矩形', x, y, width, height)
        },
        getLastPosition: function () {
            return this.positionList.slice(-1)
        },
        setPosition: function (type, x, y, width, height) {
            var last = this.getLastPosition()
            var position = '<span class="positionX">' + x.toFixed(2) + '</span>,<span class="positionY">' + y.toFixed(2) + '</span>,<span class="positionR">' + width.toFixed(2) + '</span">'
            if (type !== '圆形') {
                position = '<span class="positionX">' + x.toFixed(2) + '</span>,<span class="positionY">' + y.toFixed(2) + '</span>,<span class="positionR">' + (x + width).toFixed(2) + '</span>,<span class="positionR">' + (y + height).toFixed(2) + '</span>'
            }
            var listSoundName = ''
            if (this.uploadSoundFileList.length > 0) {
                listSoundName = this.uploadSoundFileList[this.uploadSoundFileList.length - 1].name
            }
            return {
                num: this.positionList.length + 1,
                photoName: this.photoName,
                type: type,
                position: (type === '圆形') ? (x.toFixed(2) + ',' + y.toFixed(2) + ',' + width.toFixed(2)) : (x.toFixed(2) + ',' + y.toFixed(2) + ',' + (x + width).toFixed(2) + ',' + (y + height).toFixed(2)),
                positionDes: position,
                start: (last.length > 0 ? last[0].end : 0) + 0.1,
                end: (last.length > 0 ? last[0].end : 0) + 2,
                soundFileName: (last.length > 0 ? last[0].soundFileName : listSoundName),
                soundFilePath: (last.length > 0 ? last[0].soundFilePath : '')
            }
        },
        clear: function () {
            this.$confirm('此操作将永久清除当前已绘坐标, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.positionList = []
                this.uploadSoundFileList = []
                this.uploadSoundFile = []
                if (this.originImg) {
                    this.loadCanvas(this.originImg)
                }
            })
        },
        clearLast: function () {
            var _this = this
            if (_this.positionList.length > 0) {
                _this.positionList.pop()
                if (_this.originImg) {
                    _this.loadCanvas(_this.originImg)
                }
            }
        },
        radiochange: function () {
            this.dorowDemo(true)
        },
        numberChange: function () {
            this.dorowDemo(true)
        },
        beforeAvatarUpload (file) {
            var _this = this
            _this.demoShow = true
            _this.uploadFile = file.raw

            const URL = window.URL || window.webkitURL
            var objUrl = URL.createObjectURL(file.raw)
            _this.originImg = objUrl
            var _img = new Image()
            _img.src = objUrl
            _img.onload = function () {
                _this.imgWidth = _img.width
                _this.imgHeight = _img.height
            }

            _this.drawThrumnail()// 绘制缩略图
            _this.photoName = file.name
            _this.positionList = []
            _this.loadPosition(file.name.split('.')[0])
        },
        beforeSoundUpload (file) {
            var _this = this
            const URL = window.URL || window.webkitURL
            var objUrl = URL.createObjectURL(file.raw)

            _this.pushUnExistObj(_this.uploadSoundFile, file.raw.name, file.raw)
            _this.pushUnExistObj(_this.uploadSoundFileList, file.raw.name, { name: file.raw.name, url: objUrl })
        },
        pushUnExistObj: function (target, compareValue, value) {
            var count = Enumerable.from(target).count(c => c.name === compareValue)
            if (count === 0) {
                target.push(value)
            }
        },
        saveData: function () {
            var _this = this
            if (this.positionList.length === 0) {
                _this.$message({ message: '请先点击画布，编辑坐标', type: 'warning' })
                return
            }
            _this.loading = true
            var formData = new window.FormData()
            formData.append('productCode', _this.productCode)
            formData.append('filename', _this.uploadFile.name)
            formData.append('imageHeight', _this.imgHeight)
            formData.append('imageWidth', _this.imgWidth)
            formData.append('thurmbnail', _this.thurmbnailBase64)
            formData.append('file', _this.uploadFile)
            _this.uploadSoundFile.forEach(function (file) {
                formData.append('file', file)
            })
            formData.append('positions', JSON.stringify(this.positionList))

            return this.$axios.post(api.uploadPosition, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(res => {
                    if (res.data.result === 'SUCCESS') {
                        _this.loading = false
                        _this.$message({ message: '保存完成', type: 'success' })
                        _this.isSaved = true
                        return true
                    } else {
                        _this.loading = false
                        _this.$message({ message: res.data.result, type: 'error' })
                        return false
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    _this.$message({ message: error.message, type: 'error' })
                    _this.loading = false
                    return false
                })
        },
        drawThrumnail () {
            var _this = this
            const img = new Image()
            var canvas = _this.$refs.thrumbCanvas
            const ctx = canvas.getContext('2d')
            canvas.width = 210
            canvas.height = 210 / canvas.width * canvas.height
            img.src = _this.originImg
            img.onload = function () {
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
                _this.thurmbnailBase64 = canvas.toDataURL('image/png')
            }
        },
        audioPlay: function (event, row) {
            // console.log(event, row, 'audioPlay')
            row.start = event.target.currentTime
        },
        audioPause: function (event, row) {
            // console.log(event, row, 'audioPause')
            row.end = event.target.currentTime
        },
        expandChange: function (row, expandRows) {
            // this.expandKeys = []
            if (this.expandKeys.length > 0 && this.expandKeys[0] === row.num) {
                this.expandKeys = []
            } else {
                this.expandKeys = []
                this.expandKeys.push(row.num)
            }
        },
        drawHander: function () {
            if (this.uploadFile === '') {
                this.$message({ message: '请先选择上传要操作的图片', type: 'warning' })
                return
            }
            if (this.uploadSoundFileList.length === 0) {
                this.$message({ message: '请先选择上传要操作的语音', type: 'warning' })
                return
            }
            this.drawerShow = true
            if (this.positionList.length > 0 && !this.isSaved) {
                return
            }
            const URL = window.URL || window.webkitURL
            var objUrl = URL.createObjectURL(this.uploadFile)
            this.loadCanvas(objUrl)
        },
        setImageSize: function (h) {
            var img = this.$refs.photo
            // 避免上一个图设置影响下一个图
            img.style.height = ''
            img.style.width = ''
            var cava = this.$refs.mycanvas
            cava.style.height = ''
            cava.style.width = ''
            var height = window.innerHeight - 70
            if (h >= height) {
                img.style.height = (height + 5) + 'px'
                cava.style.height = height + 'px'
            } else {
                // img.style.width = '90%' 宽度必须是100%
                cava.style.width = '90%'
            }
            this.$refs.leftcol.$el.setAttribute('style', 'height:' + (height + 10) + 'px')
        },
        popImage: function (event, row) {
            var _this = this
            this.$nextTick(function () {
                // console.log(document.getElementsByClassName('el-image-viewer__img').length, 'sss')
                var viewimg = document.getElementsByClassName('el-image-viewer__img')[0]
                viewimg.onload = function () {
                    viewimg.setAttribute('usemap', '#planetmap')
                    // console.log(row.productCode, 'row.productCode')
                    _this.playView((row !== undefined ? row.productCode : _this.uploadFile.name.replace('.jpg', '')), viewimg)
                }
            })
        },
        playView: function (productCode, img) {
            this.drawer = true
            var _this = this
            _this.mapdPositionList = []
            _this.loading = true
            _this.$axios.get(api.getPositionsByProductCode(productCode))
                .then(res => {
                    _this.mapdPositionList = res.data.result
                    var currentWidth = img.clientWidth
                    if (_this.mapdPositionList.length > 0) {
                        _this.rate = currentWidth * 1.00 / res.data.result[0].imageWidth
                    }
                    _this.loading = false
                }
                )
        },
        loadPosition: function (productCode, img) {
            var _this = this
            _this.$axios.get(api.getPositionsByProductCode(productCode))
                .then(res => {
                    _this.positionList = []
                    _this.loading = false
                    if (res.data.result.length > 0) {
                        _this.isSaved = true
                    } else {
                        return
                    }
                    res.data.result.forEach(function (item) {
                        // 重复文件不需要增加
                        _this.pushUnExistObj(_this.uploadSoundFileList, item.soundName, { name: item.soundName, url: item.soundPath })
                        if (item.selectType === 1) {
                            var p = _this.setPosition('圆形', item.x, item.y, item.r)
                            p.soundFileName = item.soundName
                            p.soundFilePath = item.soundPath
                            p.start = item.soundStart
                            p.end = item.soundEnd
                            _this.positionList.push(p)
                        } else {
                            var pp = _this.setPosition('矩形', item.x, item.y, item.x1 - item.x, item.y1 - item.y)
                            pp.soundFileName = item.soundName
                            pp.soundFilePath = item.soundPath
                            pp.start = item.soundStart
                            pp.end = item.soundEnd
                            _this.positionList.push(pp)
                        }
                    })
                }
                )
        },
        getAudioByName: function (row) {
            var current = this.uploadSoundFileList.find(f => f.name === row.soundFileName)
            return current.url
        },
        viewHandle: function (event, item) {
            this.popImage(event, item)
        },
        getCoords: function (position) {
            if (position.selectType === 1) {
                return (position.x * this.rate).toFixed(0) + ',' + (position.y * this.rate).toFixed(0) + ',' + (position.r * this.rate).toFixed(0)
            } else {
                return (position.x * this.rate).toFixed(0) + ',' + (position.y * this.rate).toFixed(0) + ',' + (position.x1 * this.rate).toFixed(0) + ',' + (position.y1 * this.rate).toFixed(0)
            }
        },
        getXY: function (position) {
            if (position.selectType === 1) {
                return (position.x * this.rate).toFixed(0) + ',' + (position.y * this.rate).toFixed(0) + ',' + (position.r * this.rate).toFixed(0)
            } else {
                return (position.x * this.rate).toFixed(0) + ',' + (position.y * this.rate).toFixed(0) + ',' + (position.x1 * this.rate).toFixed(0) + ',' + (position.y1 * this.rate).toFixed(0)
            }
        },
        setCurEndTimeAndPlay: function (startTime, endTime, soundPath) {
            try {
                var _this = this
                if (_this.$refs.myAudio.src !== soundPath) {
                    _this.$refs.myAudio.src = soundPath
                }
                console.log(_this.$refs.myAudio.src, soundPath)
                _this.$refs.myAudio.currentTime = startTime
                _this.$refs.myAudio.play()
                var pausingFunction = function () {
                    if (_this.$refs.myAudio.currentTime >= endTime) {
                        _this.$refs.myAudio.pause()
                        _this.$refs.myAudio.removeEventListener('timeupdate', pausingFunction)
                    }
                }
                _this.$refs.myAudio.addEventListener('timeupdate', pausingFunction)
            } catch (error) {
                this.$message({ message: '播放错误', type: 'error' })
            }
        }
    }
}
</script>
<style scoped lang="less">
.mian {
    width: 100%;
    margin: 10px;
}

.product-card {
    width: 240px;
    float: left;
    margin: 0 10px 10px 0;
    text-align: center;
}

.image-slot {
    line-height: 143px;
    color: var(--text-placeholder);
}

.image-slot i {
    vertical-align: middle;
    font-size: 80px;
}

.product-card span {
    color: var(--text-secondary);
    font-size: 13px;
}

.mian>div>div {
    margin: 5px 0px;
    padding: 5px;
}

.title {
    font-size: 16px;
    text-align: center;
    word-wrap: break-word;
}

/deep/.main-body {
    margin: 0;
    padding: 0;
}

.photo {
    margin: 0 auto;
    overflow: auto;
    text-align: center;
    padding-top: 10px;
}

canvas {
    // width: 100%;
    position: relative;
    border-radius: 5px;
}

/deep/.el-upload {
    border: 1px solid var(--border-base);
    border-radius: 3px;
    transition: .2s;
    background-color: var(--bg-base);
}

/deep/ .el-form-item__label {
    font-weight: 700;
    font-size: 16px;
}

.avatar-uploader {
    display: inline;
}

.avatar-uploader .avatar-uploader-icon {
    font-size: 28px;
    color: var(--text-placeholder);
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}

.canvasDemo {
    margin: 0 auto;
    margin-top: 15px;
}

.table {
    margin-top: 10px;
}

/deep/.positionX {
    color: #f87171;
    margin: 0 5px;
}

/deep/.positionY {
    color: #60a5fa;
    margin: 0 5px;
}

/deep/.positionR {
    color: #fbbf24;
    font-weight: 700;
    margin: 0 5px;
}

.drawer-left {
    padding: 0px 20px;
    background-color: var(--bg-elevated);
    box-shadow: 4px 5px 5px var(--shadow-base);
    height: 100%;
    text-align: center;
}

/deep/.el-drawer__header {
    margin-bottom: 0px;
    padding: 10px 20px;
    text-align: right;
    background-color: var(--bg-elevated);
    font-size: 18px;
    font-weight: 700;
    box-shadow: 5px 3px 5px var(--shadow-base);
    color: var(--text-primary);
}

.img-size span {
    color: var(--text-secondary);
    font-weight: 700;
    padding-right: 10px;
}

.file-extend {
    color: coral;
    font-weight: 700;
    display: inline-block;
    padding-left: 5px;
    line-height: 35px;
}

.table-audio {
    text-align: center;
}

.table-audio audio {
    width: 60%;
}

.upload-filelist {
    list-style: none;
}

.upload-filelist i {
    color: #E6A23C;
    font-size: 13px !important;
    font-weight: 700;
    padding-right: 10px;
}

.upload-filelist span {
    color: var(--text-secondary);
}

/deep/.thrumbnail-show>div>img {
    width: 210px;
    margin: 0 10px 10px;
}

/deep/#pane-7 {
    padding-top: 0px !important;
}

.clear-span {
    color: var(--text-secondary);
    font-size: 12px;
    padding-right: 10px;
}

/deep/.el-form-item__content {
    overflow-x: auto;
    overflow-y: hidden;
}

.sound-time {
    color: #67C23A;
}

.sound-time-end {
    padding-left: 10px;
    color: #F56C6C;
}
</style>



// WEBPACK FOOTER //
// src/components/bg/PhotoEdit.vue